import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://localhost:4000'
  baseURL:'https://server-pg.onrender.com'
  // baseURL:'https://valuationshub-api.onrender.com'
})

export default api;